module.exports = __webpack_public_path__ + "img/floor-market.106af036.png";